export default {


  reg(email) {
    return env.API.post('/auth/quick/reg', {
      email
    });
  },


  changePass(password) {
    return env.API.put('/auth/quick/pass', {
      password
    });
  },
}
